import axiosFacturation from 'config/axiosFacturation';

import { animationUrl } from 'config/endpoints';

export const useAdminWriterBilling = ({
  writerCommandId,
  setErrorSuccessMsg,
  setErrorSuccessImg,
  setIsSuccess,
  t,
}) => {
  const generateBillAdminForWriterCommand = async () => {
    try {
      await axiosFacturation.get(
        `/admin/GenerateBill?writerCommandId=${writerCommandId}`
      );

      setIsSuccess(true);
    } catch (error) {
      setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
      setIsSuccess(false);
    }
  };

  const checkAllValidatedAndGenerateBill = async () => {
    try {
      const res = await axiosFacturation.get(
        `/admin/allDeliveredTexts?writerCommandId=${writerCommandId}`
      );

      if (res.data === true) {
        setErrorSuccessMsg(`${t('Le dernier texte a été livré avec succès')}!`);
        setErrorSuccessImg(animationUrl + '/06_Commande_livrée.gif');
        generateBillAdminForWriterCommand();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    generateBillAdminForWriterCommand,
    checkAllValidatedAndGenerateBill,
  };
};
